import api from "./api";
import { API_URL_VERSION } from "constants/environment";
import { toSearchFilter } from "utils";

export const ENDPOINT_VIOLATION_ALLOTMENTS = API_URL_VERSION + "lotes";
export const ENDPOINT_VIOLATION_ALLOTMENTS_VALIDATION_LIST = ENDPOINT_VIOLATION_ALLOTMENTS + "/validacao";
export const ENDPOINT_VIOLATION_ALLOTMENT_INFRACTIONS = `${ENDPOINT_VIOLATION_ALLOTMENTS}/:id/infracoes`;
export const ENDPOINT_VIOLATION_ALLOTMENT_PRINT_AIT = API_URL_VERSION + "lotes/imprimir-ait-pdf";

export const AllotmentStatus = {
  OPEN: { value: "ABERTO" },
  PROCESSING: { value: "EM PROCESSAMENTO" },
  CLOSED: { value: "FECHADO" },
}

export const violationAllotmentsValidationService = {
  list: async (params = {}) => {
    try {
      const response = await api.get(ENDPOINT_VIOLATION_ALLOTMENTS_VALIDATION_LIST, { params: toSearchFilter(params) });
      return { content: response.data?._embedded?.content ?? [] };
    } catch (error) {
      throw error.response?.data?.message || "violation-allotments.messages.errors.list";
    }
  },

  findMany: async (data) => {
    try {
      const response = await api.get(ENDPOINT_VIOLATION_ALLOTMENTS, data);
      return response.data;
    } catch (error) {
      console.log(error)
      throw error.response?.data?.message || "violation-allotments.messages.errors.find-many";
    }
  },

  create: async (data) => {
    try {
      const response = await api.post(ENDPOINT_VIOLATION_ALLOTMENTS, data);
      return response.data;
    } catch (error) {
      throw error.response?.data?.message || "violation-allotments.messages.errors.create";
    }
  },

  find: async (id) => {
    try {
      const response = await api.get(`${ENDPOINT_VIOLATION_ALLOTMENTS}/${id}`);
      return response.data;
    } catch (error) {
      throw error.response?.data?.message || "violation-allotments.messages.errors.find";
    }
  },

  update: async (id, data) => {
    try {
      const response = await api.put(`${ENDPOINT_VIOLATION_ALLOTMENTS}/${id}`, data);
      return response.data;
    } catch (error) {
      throw error.response?.data?.message || "violation-allotments.messages.errors.update";
    }
  },

  listViolations: async (id, params = {}) => {
    try {
      const response = await api.get(ENDPOINT_VIOLATION_ALLOTMENT_INFRACTIONS.replace(":id", id), { params });
      return response.data._embedded.infracao_by_lote_dtolist;
    } catch (error) {
      throw error.response?.data?.message || "violation-allotments.messages.errors.list-violations";
    }
  },

  updateStatus: async (id, status) => {
    try {
      const response = await api.patch(`${ENDPOINT_VIOLATION_ALLOTMENTS}/${id}`, { status: status });
      return response.data;
    } catch (error) {
      throw error.response?.data?.message || "violation-allotments.validation.messages.errors.update";
    }
  },

  printAit: async (id) => {
    try {
      const response = await api.get(`${ENDPOINT_VIOLATION_ALLOTMENT_PRINT_AIT}/${id}`, {
        responseType: 'blob'
      });
      return response;
    } catch (error) {
      throw error.response?.data?.message || "violation-allotments.validate.messages.errors.print-ait";
    }
  },

};
